import { render, staticRenderFns } from "./OptionUserInformation.vue?vue&type=template&id=2d63bf91"
import script from "./OptionUserInformation.vue?vue&type=script&lang=js"
export * from "./OptionUserInformation.vue?vue&type=script&lang=js"
import style0 from "./OptionUserInformation.vue?vue&type=style&index=0&id=2d63bf91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports